import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-steps',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-steps works!</p> `,
  styles: ``,
})
export class CpStepsComponent {}
